import { Button } from 'shared/components/ui';
import React from 'react';

import { Edit, Notifications } from '@mui/icons-material';
import { calcularEdad, formatearFecha, formatearHorario, getColorPrioridad } from '../../../shared/utils/dateUtils';
import { getNombreProcesador } from '../../turnos/utils/turnoUtils';
import { PRIORIDAD_COLORS, DEFAULT_VALUES } from '../../../core/constants';
import StatusBadge from '../../../shared/components/StatusBadge';

const PracticaRow = React.memo(({ turno, procesadores, onEditar, onNotificar, loading, mostrarTodasColumnas }) => {
  const colorPrioridad = getColorPrioridad(
    turno.fechaEntrega,
    turno.solicitado,
    PRIORIDAD_COLORS
  );
  
  const procesador = getNombreProcesador(turno.idProcesador, procesadores);

  return (
    <tr style={colorPrioridad ? { borderLeft: `4px solid ${colorPrioridad}` } : {}}>
      <td className="dni-cell">{turno.idTurno}</td>
      <td className="dni-cell">{turno.persona?.dni || DEFAULT_VALUES.NO_DATA_DASH}</td>
      <td className="patient-cell" title={turno.persona ? `${turno.persona.apellido}, ${turno.persona.nombre}` : DEFAULT_VALUES.NO_DATA_DASH}>
        {turno.persona ? `${turno.persona.apellido}, ${turno.persona.nombre}` : DEFAULT_VALUES.NO_DATA_DASH}
      </td>
      <td>{turno.persona?.fechaNacimiento ? calcularEdad(turno.persona.fechaNacimiento) : DEFAULT_VALUES.NO_DATA_DASH}</td>
      <td title={turno.persona?.telCelular}>{turno.persona?.telCelular || DEFAULT_VALUES.NO_DATA_DASH}</td>
      <td className="estudio-cell" title={turno.tipoEstudio?.tipoEstudio}>{turno.tipoEstudio?.tipoEstudio || DEFAULT_VALUES.NO_DATA_DASH}</td>
      <td>{turno.horario?.inicio ? formatearFecha(turno.horario.inicio) : DEFAULT_VALUES.NO_DATA_DASH}</td>
      {mostrarTodasColumnas && (
        <>
          <td title={formatearHorario(turno.horario?.inicio, turno.horario?.fin)}>{formatearHorario(turno.horario?.inicio, turno.horario?.fin)}</td>
          <td title={turno.idEquipoNavigation?.equipo1}>{turno.idEquipoNavigation?.equipo1 || DEFAULT_VALUES.NO_DATA_DASH}</td>
          <td title={turno.idEquipoCpapNavigation?.equipo1}>{turno.idEquipoCpapNavigation?.equipo1 || DEFAULT_VALUES.NO_DATA_DASH}</td>
          <td>{turno.fechaEntrega ? formatearFecha(turno.fechaEntrega) : DEFAULT_VALUES.NO_DATA_DASH}</td>
          <td title={turno.persona?.obraSocial?.obraSocial}>{turno.persona?.obraSocial?.obraSocial || DEFAULT_VALUES.NO_DATA_DASH}</td>
          <td>
            {turno.urgente ? (
              <span style={{ background: '#dc3545', color: '#fff', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 }}>
                INFORME
              </span>
            ) : DEFAULT_VALUES.NO_DATA_DASH}
          </td>
        </>
      )}
      <td className="estado-cell">
        <StatusBadge
          estado={turno.estadosTurno?.estadoTurno}
          procesador={procesador}
          subEstado={turno.subEstado}
        />
      </td>
      <td>
        <div style={{ display: 'flex', gap: '0.3rem' }}>
          <Button
            onClick={() => onEditar(turno.idTurno)}
            disabled={loading}
            className="btn-edit"
            title="Editar"
            sx={{ bgcolor: '#3b82f6 !important', color: '#fff !important', '&:hover': { bgcolor: '#2563eb !important' } }}
          >
            <Edit sx={{ fontSize: 16 }} />
          </Button>
          <Button
            onClick={() => onNotificar(turno.idTurno)}
            disabled={loading}
            variant="success"
            size="sm"
            title="Notificar"
            sx={{ bgcolor: '#16a34a !important', color: '#fff !important', '&:hover': { bgcolor: '#15803d !important' } }}
          >
            <Notifications sx={{ fontSize: 16 }} />
          </Button>
        </div>
      </td>
    </tr>
  );
});

PracticaRow.displayName = 'PracticaRow';

export default PracticaRow;
